"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PPPermissions = /** @class */ (function () {
    function PPPermissions(groups) {
        this.groups = groups;
    }
    PPPermissions.prototype.canAccess = function (path, user, operation) {
        var _this = this;
        var hasPathPermission = false;
        var hasOperationPermission = false;
        var splittedPath = path.split("|");
        var checkOperation = function (_operations) {
            if (_operations) {
                if (typeof _operations === "string" &&
                    (_operations === operation || _operations === "*"))
                    return true;
                else if (Array.isArray(_operations))
                    return _operations.includes(operation);
            }
            return !!_operations || true;
        };
        var hasNestedPermission = function (pathObject) {
            var splitted = pathObject.split("|").reverse();
            var arrayContainsArray = function (arr1, arr2) {
                return arr2.every(function (v) { return arr1.includes(v); });
            };
            hasPathPermission = arrayContainsArray(splittedPath, splitted);
            return hasPathPermission;
        };
        var checkPath = function (_path) {
            if (!_path)
                return true;
            if (typeof _path === "string") {
                hasNestedPermission(_path);
            }
            else if (Array.isArray(_path)) {
                _path.some(function (pathObject) {
                    if (typeof pathObject === "string") {
                        return hasNestedPermission(pathObject);
                    }
                    else if (typeof pathObject === "object") {
                        hasNestedPermission(pathObject.name);
                        checkOperation(pathObject.operations);
                        return true;
                    }
                    return false;
                });
            }
            return hasPathPermission;
        };
        user.groups.some(function (groupName) {
            var group = _this.groups.find(function (g) { return g.name === groupName; });
            if (!group)
                return true;
            var _operations = group.operations, _paths = group.paths;
            if (!_operations && !_paths) {
                hasOperationPermission = hasPathPermission = true;
                return true;
            }
            hasOperationPermission = checkOperation(_operations);
            hasPathPermission = checkPath(_paths);
            if (hasOperationPermission && hasPathPermission)
                return true;
            return false;
        });
        return hasPathPermission && hasOperationPermission;
    };
    return PPPermissions;
}());
exports.default = PPPermissions;
